import React, { useCallback, useEffect } from "react";
import LabelHelper from "../Helpers/LabelHelper";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import LoginHelper from "../../globalHelpers/LoginHelper";
import Cookies from "universal-cookie";
import Spinner from "../Components/Spinner";

const cookies = new Cookies();
const loginStepTimeoutMs = 15000;

function withTimeout(promise, timeoutMs = loginStepTimeoutMs) {
    const errorMessage = LabelHelper.fetch("1191");
    return Promise.race([
        promise,
        new Promise((resolve) =>
            setTimeout(
                () =>
                    resolve({
                        error: { message: errorMessage },
                    }),
                timeoutMs,
            ),
        ),
    ]);
}

function CrossSiteLogin() {
    const login = useCallback(async () => {
        try {
            const tokenId = window.location.href.split("/").pop();

            if (!tokenId) {
                createLoginError({
                    message: LabelHelper.fetch("1191"),
                });
                return;
            }

            const oneTimeToken = await withTimeout(
                Express.callAsyncPublic("fetch-one-time-login-token", {
                    tokenId,
                }),
            );

            if (!oneTimeToken || oneTimeToken.error) {
                createLoginError({
                    message:
                        (oneTimeToken &&
                            oneTimeToken.error &&
                            oneTimeToken.error.message) ||
                        LabelHelper.fetch("1191"),
                });
                return;
            }

            if (oneTimeToken && oneTimeToken.customFields) {
                const { creds, keyId } = oneTimeToken.customFields;

                const sessionResults = await withTimeout(
                    Express.callAsyncPublic("cross-site-login", {
                        creds,
                        keyId,
                    }),
                );

                if (!sessionResults || sessionResults.error) {
                    createLoginError({
                        message:
                            (sessionResults &&
                                sessionResults.error &&
                                sessionResults.error.message) ||
                            LabelHelper.fetch("1191"),
                    });
                    return;
                }

                cookies.set(
                    "LoginAuthentication",
                    sessionResults.authentication,
                );

                window.localStorage.setItem(
                    "authenticationId",
                    sessionResults.authentication,
                );

                if (sessionResults && sessionResults.userId) {
                    window.sessionStorage.setItem(
                        "userId",
                        sessionResults.userId,
                    );
                }

                if (sessionResults && sessionResults.roles) {
                    window.sessionStorage.setItem(
                        "roles",
                        JSON.stringify(sessionResults.roles),
                    );
                }

                if (!window.siteSettings || !window.siteSettings.twoFactorOn) {
                    LoginHelper.afterLogin(sessionResults);
                    return;
                }

                const device = cookies.get("device-" + sessionResults.userId);

                const twoFactorOn = await withTimeout(
                    Express.callAsync("check-two-factor", {
                        userId: sessionResults.userId,
                        deviceId: device,
                    }),
                );

                if ((twoFactorOn && twoFactorOn.passed) || !device) {
                    createLoginError({
                        errorReponse: "Open2FactorModal",
                        responseValue: JSON.stringify({
                            username: sessionResults.username,
                            session: sessionResults,
                        }),
                    });
                } else {
                    LoginHelper.afterLogin(sessionResults);
                }
            } else {
                createLoginError({
                    message: LabelHelper.fetch("1191"),
                });
            }
        } catch (error) {
            console.log(error);
            createLoginError({
                message: LabelHelper.fetch("1191"),
            });
        }
    }, []);

    useEffect(() => {
        login();
    }, [login]);

    function createLoginError({ errorReponse, responseValue, message }) {
        if (errorReponse && responseValue) {
            window.localStorage.setItem(errorReponse, responseValue);
        }

        if (message) {
            window.localStorage.setItem("globalMessage", message);
        }

        window.location.href = "/";
    }

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: "50px",
            }}
        >
            <Spinner width="50px" />
            <span style={{ padding: "10px" }}>Logging in...</span>
        </div>
    );
}

export default CrossSiteLogin;
